import * as React from 'react'

export const OpenMenuIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="5"
    height="10"
    viewBox="0 0 5 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.894764 0.176922L4.82805 4.6058C4.93552 4.74493 5 4.88406 5 5.02318C5 5.16231 4.95701 5.27825 4.87104 5.39419L0.937752 9.82311C0.722817 10.055 0.400421 10.055 0.206976 9.84626C-0.00795162 9.63756 -0.00795163 9.28971 0.185486 9.05786L3.75338 5.02318L0.142497 0.942121C-0.0509405 0.733434 -0.0509405 0.362424 0.163995 0.153734C0.378923 -0.0549565 0.701326 -0.0549565 0.894764 0.176922Z"
      fill="#282421"
    />
  </svg>
)
